<script setup lang="ts">
// Тонкая обёртка над @mdi/js: SVG-spans с одним path, без рантайм-зависимости
// от шрифта или sprite-сетки. На клиенте легче, чем @mdi/font (CSS + woff2),
// и не тянет лишних иконок — bundler tree-shake'ает только используемые.

defineProps<{
    path: string;
    size?: number | string;
    title?: string;
}>();
</script>

<template>
    <svg
        :width="size ?? 20"
        :height="size ?? 20"
        viewBox="0 0 24 24"
        fill="currentColor"
        :aria-label="title"
        :role="title ? 'img' : 'presentation'"
        focusable="false"
    >
        <title v-if="title">{{ title }}</title>
        <path :d="path" />
    </svg>
</template>